import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/context/store';

import { EUserLoginOption, IUser } from './UserTypes';

// Define the initial state using that type
const initialState: IUser = {
    isLoggedIn: false,
    mobileOrEmail: EUserLoginOption.MOBILE,
    loginUrl: '',
};

export const userSlice = createSlice({
    name: 'user',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
            state.isLoggedIn = action.payload;
        },

        setMobileOrEmail: (state, action: PayloadAction<EUserLoginOption>) => {
            state.mobileOrEmail = action.payload;
        },

        setLoginUrl: (state, action: PayloadAction<string>) => {
            state.loginUrl = action.payload;
        },
    },
});

export const { setIsLoggedIn, setLoginUrl, setMobileOrEmail } =
    userSlice.actions;

export function selectUser(state: RootState): IUser {
    return state.userReducer;
}
export function selectIsLoggedIn(state: RootState): boolean {
    return state.userReducer.isLoggedIn;
}
export function selectMobileOrEmail(state: RootState): EUserLoginOption | null {
    return state.userReducer.mobileOrEmail;
}

export function selectLoginUrl(state: RootState): string {
    return state.userReducer.loginUrl;
}

export const userReducer = userSlice.reducer;
